import { render, staticRenderFns } from "./EcosystemOrbit.vue?vue&type=template&id=5744bdd0&scoped=true"
import script from "./EcosystemOrbit.vue?vue&type=script&lang=js"
export * from "./EcosystemOrbit.vue?vue&type=script&lang=js"
import style0 from "./EcosystemOrbit.vue?vue&type=style&index=0&id=5744bdd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5744bdd0",
  null
  
)

export default component.exports